
      <!-- Default box -->
      <div class="card card-info"  [ngClass]="{'dark-bg' : isDark }">
        <div class="card-header">Vehicle Register</div> 
        <form [formGroup] ="itemForm" autocomplete="off" (ngSubmit)="saveButtonClick()" class="form-horizontal" enctype="multipart/form-data">
        <div class="card-body">  

        <div class="form-group row">
            <input  name="id" readonly formControlName="id"  class="form-control"    type="hidden">
        </div>
  
          <div class="row">
            <div class="col-md-4">
              <div class="form-group">
                <label for="vehicleId" class="col-form-label">Vehicle Id</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text"  [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-hashtag"></i></span>
                  </div>
                  <input type="text"  [ngClass]="{'dark-input-field' : isDark }" readonly formControlName="vehicleId" class="form-control field-bg-color"  placeholder="Vehicle Id" [class.is-invalid]="formErrors.vehicleId" (blur)="logValidationErrors()">
                </div>
                <span class="text-danger" *ngIf="formErrors.vehicleId"><small>{{formErrors.vehicleId}}</small> </span> 
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label for="vehicleNo" class="col-form-label">Vehicle No</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text"  [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-bars"></i></span>
                  </div>    
                  <input  [ngClass]="{'dark-input-field' : isDark }" class="form-control" formControlName="vehicleNo"  [class.is-invalid]="formErrors.vehicleNo" (blur)="logValidationErrors()" placeholder="Vehicle No">
                </div>
                <span class="text-danger" *ngIf="formErrors.vehicleNo"><small>{{formErrors.vehicleNo}}</small> </span>   
              </div>
            </div> 
            <div class="col-md-4">
                <div class="form-group">
                  <label for="brand" class="col-form-label">Brand</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text"  [ngClass]="{'dark-input-field' : isDark }"><i class="far fa-list-alt"></i></span>
                    </div>
                    <input type="text"  [ngClass]="{'dark-input-field' : isDark }" formControlName="brand" class="form-control"  placeholder="Brand" [class.is-invalid]="formErrors.brand" (blur)="logValidationErrors()">
                  </div>
                  <span class="text-danger" *ngIf="formErrors.brand"><small>{{formErrors.brand}}</small> </span> 
                </div>
              </div> 

          </div>
  
          <div class="row">
              
            <div class="col-md-4">
                <div class="form-group">
                  <label for="model" class="col-form-label">Model</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text"  [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-cubes"></i></span>
                    </div>
                    <input type="text"  [ngClass]="{'dark-input-field' : isDark }" formControlName="model" class="form-control"  placeholder="Model">
                  </div>  
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group">
                  <label for="color" class="col-form-label">Color</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text"  [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-edit"></i></span>
                    </div>
                    <input type="text"  [ngClass]="{'dark-input-field' : isDark }" formControlName="color" class="form-control"  placeholder="Color">
                  </div>               
                </div>
              </div> 
              <div class="col-md-4">
                <div class="form-group">
                  <label for="purchaseDate" class="col-form-label">Purchase Date </label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text" [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-calendar-o"></i></span>
                    </div>
                    <input type="text" [ngClass]="{'dark-input-field' : isDark }" bsDatepicker [bsConfig]="datepickerConfig" formControlName="purchaseDate" class="form-control field-bg-color"   placeholder="Purchase Date">
                  </div>
                </div>
              </div>
       
          </div>

          <div class="row">
              
            <div class="col-md-4">
                <div class="form-group">
                  <label for="purchaseCost" class="col-form-label">Purchase Cost</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text"  [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-cubes"></i></span>
                    </div>
                    <input type="text"  [ngClass]="{'dark-input-field' : isDark }" formControlName="purchaseCost" class="form-control"  placeholder="Purchase Cost">
                  </div>  
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group">
                  <label for="leaseValue" class="col-form-label">Lease Value</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text"  [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-edit"></i></span>
                    </div>
                    <input type="text"  [ngClass]="{'dark-input-field' : isDark }" formControlName="leaseValue" class="form-control"  placeholder="Lease Value">
                  </div>               
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group">
                  <label for="installment" class="col-form-label">Installment</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text"  [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-edit"></i></span>
                    </div>
                    <input type="text"  [ngClass]="{'dark-input-field' : isDark }" formControlName="installment" class="form-control"  placeholder="Installment">
                  </div>               
                </div>
              </div>
              
              </div>

              <div class="row">
              
                <div class="col-md-4">
                    <div class="form-group">
                      <label for="leasePeriod" class="col-form-label">Lease Period</label>
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text"  [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-cubes"></i></span>
                        </div>
                        <input type="text"  [ngClass]="{'dark-input-field' : isDark }" formControlName="leasePeriod" class="form-control"  placeholder="Lease Period">
                      </div>  
                    </div>
                  </div>
    
                  <div class="col-md-4">
                    <div class="form-group">
                      <label for="paymentDate" class="col-form-label">PaymentDate</label>
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text"  [ngClass]="{'dark-input-field' : isDark }"><i class="fa fa-edit"></i></span>
                        </div>
                        <input type="text"  [ngClass]="{'dark-input-field' : isDark }" formControlName="paymentDate" class="form-control"  placeholder="Payment Date">
                      </div>               
                    </div>
                  </div>  
                  
                </div>
      
        </div>
        <!-- /.card-body -->
        <div class="card-footer">
         <button type="button" (click)="newButtonClick()" class="btn btn-success ml-2">New</button>

          <button *ngIf="crud_access.create"  type="submit"  class="btn btn-info ml-2">
           <span *ngIf ="showProcessingIndicator" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            Save
          </button>
  
          <button type="button" class="btn btn-primary ml-2" routerLink="../vehicle-list"><i class="fa fa-table p-1"></i>Vehicle List</button>
        </div>
        <!-- /.card-footer-->
        </form>
      </div>

  



